// extracted by mini-css-extract-plugin
module.exports = {"scroller":"Slider_scroller__T4Kr9","hideScroll":"Slider_hideScroll__HXlaX","navigation":"Slider_navigation__sYal5"};